import PurchaseSubscriptionDialog from "@/dialogs/purchase-subscription-dialog";
import UpgradeSubscriptionToPro from "@/dialogs/upgrade-subscription-to-pro";
import { UserTypeLockUpdateSubscription } from "@/dialogs/user-type-lock-update-subscription";
import { useAccountStore } from "@/features/account-management";
import { useAuthStore } from "@/features/authentication";
import { store } from "@store";
import { openDialog } from "@store/dialogs";

export const openProDialog = (source: string) => {
  const isAdminOrAdministrator = useAuthStore.getState().isAdminOrAdministrator;
  const hasStarter = useAccountStore.getState().planType === "starter";
  const isCancelled = useAccountStore.getState().isCancelled;

  if (!isAdminOrAdministrator) {
    store.dispatch(
      openDialog({
        id: UserTypeLockUpdateSubscription.id,
        content: UserTypeLockUpdateSubscription,
      }),
    );
    return;
  }

  if (hasStarter && !isCancelled) {
    store.dispatch(
      openDialog({
        id: "upgrade-subscription-to-pro",
        content: UpgradeSubscriptionToPro,
      }),
    );
    return;
  }

  store.dispatch(
    openDialog({
      id: "purchase-subscription",
      content: PurchaseSubscriptionDialog,
      props: { source, plan: "pro", period: "annually" },
    }),
  );
};
